import React from "react";

function Folder() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 256 256"
    >
      <g fill="currentColor">
        <path
          d="M224 88v112.89a7.11 7.11 0 01-7.11 7.11H40a8 8 0 01-8-8V64a8 8 0 018-8h53.33a8 8 0 014.8 1.6l27.74 20.8a8 8 0 004.8 1.6H216a8 8 0 018 8z"
          opacity="0.2"
        ></path>
        <path d="M216 72h-85.33l-27.74-20.8a16.12 16.12 0 00-9.6-3.2H40a16 16 0 00-16 16v136a16 16 0 0016 16h176.89A15.13 15.13 0 00232 200.89V88a16 16 0 00-16-16zm0 128H40V64h53.33l27.74 20.8a16.12 16.12 0 009.6 3.2H216z"></path>
      </g>
    </svg>
  );
}

export default Folder;
